import { h } from "@stencil/core";
import localI18n from "../../../util/i18n";
import { JwtUtil } from "../../../util/jwt-util/jwt-util";
export class SessionExpiration30MinWarnPopUp {
    constructor() {
        this.open = false;
        this.authnLevel = undefined;
        this.firstFocusableElement = undefined;
        this.lastFocusableElement = undefined;
    }
    el;
    handleKeyDown(ev) {
        const tabWasPressed = ev.key === 'Tab';
        const escapeWasPressed = ev.key === 'Escape';
        if (escapeWasPressed) {
            this.handleCloseClick();
        }
        if (!tabWasPressed) {
            return;
        }
        const tabbingForwards = !ev.shiftKey;
        if (tabbingForwards && this.el.shadowRoot.activeElement === this.lastFocusableElement) {
            this.firstFocusableElement.focus();
            ev.preventDefault();
        }
        if (!tabbingForwards && this.el.shadowRoot.activeElement === this.firstFocusableElement) {
            this.lastFocusableElement.focus({ preventScroll: false });
            ev.preventDefault();
        }
    }
    handleCloseClick() {
        this.open = false;
    }
    async eventListener(event) {
        // 30-min-popup should not open when VN is high.
        // In that case info is already shown on spinner-page
        if (this.authnLevel === 'STORK-QAA-Level-4') {
            return;
        }
        if (this.checkEvent(event)) {
            this.open = true;
            this.firstFocusableElement = this.el.shadowRoot.getElementById('session-expiration-30m-warn-popup-close');
            this.lastFocusableElement = this.el.shadowRoot.getElementById('session-expiration-30m-warn-popup-continue-btn');
            await new Promise((resolve) => setTimeout(resolve, 1));
            this.lastFocusableElement.focus();
        }
    }
    handleTokenEvent(ev) {
        const jwtValidationResult = JwtUtil.validateJwt(ev);
        if (jwtValidationResult.isValidJwt) {
            let jwt = jwtValidationResult.jwt;
            let level = jwt.payload['authn-level'];
            if (JwtUtil.isValidAuthnLevel(level)) {
                this.authnLevel = level;
            }
        }
    }
    checkEvent(event) {
        return (event.detail.nextWarningMsBeforeSessionEnd &&
            event.detail.nextWarningMsBeforeSessionEnd > 0 &&
            event.detail.msUntilSessionEnd > 0);
    }
    render() {
        return (h("div", { key: '860d24a0711bbb7460be820a864adc2ec30ceefc', class: `modal overlay ${this.open ? 'is-visible' : ''}`, id: "popupHL30", tabindex: "-1", role: "dialog", "aria-label": localI18n.t('30M_POPUP_1'), "aria-hidden": "false" }, h("div", { key: 'ac1377aa59f83cb16754a1d2d21aeb0c1794100d', class: "modal-dialog modal-dialog-centered" }, h("div", { key: 'a6f843ea848434bbd5561d9d075fdffbe0ed16ca', class: "modal-content" }, h("div", { key: '9c90924521a3a8616ca14661d11490b7000b9f82', class: "modal-header" }, h("button", { key: '1d338508a306ef47ee492367b36e78b311b95867', id: "session-expiration-30m-warn-popup-close", type: "button", class: "ba-modal-close", "data-bs-dismiss": "modal", "aria-label": localI18n.t('30M_POPUP_2'), title: localI18n.t('30M_POPUP_2'), onClick: () => this.handleCloseClick() }), h("h1", { key: '4de8c8d805af8e134adb1b9668418c8167874422', class: "modal-title" }, localI18n.t('MIN_30_HEADLINE'))), h("div", { key: '9b694f5ea301629a377ea99114a23d8d6848e049', class: "modal-body" }, h("div", { key: 'b005a0931713dec157a15f66d3a384300894e9e6', id: "session-expiration-30m-warn-popup-text" }, h("div", { key: 'ff0b5ef533df8a72940683d58bdf208a510354cb', class: "alert alert-warning ", role: "alert" }, h("p", { key: 'eec01713dba5b09c0f0879a873f384600826f4dd' }, localI18n.t('MIN_30_INFO'))), h("p", { key: 'cfa40f92ec3643cc3c511e815ea81a410f7964ca' }, localI18n.t('MIN_30_REMINDER')))), h("div", { key: '2782417d68c742c28f5c2f9efaf601df36662265', class: "modal-footer" }, h("button", { key: '01c09f72d3d9f0b31dfca49a6cf07142d5facfe7', id: "session-expiration-30m-warn-popup-continue-btn", onClick: () => this.handleCloseClick(), class: "ba-btn ba-btn-primary", type: "button" }, localI18n.t('MIN_30_BUTTON')))))));
    }
    static get is() { return "session-expiration-30m-warn-popup"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["session-expiration-30m-warn-popup.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["session-expiration-30m-warn-popup.css"]
        };
    }
    static get states() {
        return {
            "open": {},
            "authnLevel": {},
            "firstFocusableElement": {},
            "lastFocusableElement": {}
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "keydown",
                "method": "handleKeyDown",
                "target": "window",
                "capture": false,
                "passive": false
            }, {
                "name": "oiamMaxSessionExpirationWarnEvent",
                "method": "eventListener",
                "target": "window",
                "capture": false,
                "passive": false
            }, {
                "name": "oiamTokenEvent",
                "method": "handleTokenEvent",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
